{
  "general": {
    "title": "Comparar opciones",
    "intro": "Un rápido vistazo a la diferencia entre comunidad, suscripción y compra única.",
    "tableheader": "Suscripción",
    "note1": "* Opciones de compra en grupo y descuento por volumen disponibles.",
    "note2": "** Idiomas compatibles: danés, alemán, inglés, español, suomi, francés, italiano, noruego, polaco, portugués (Brasil), ruso, sueco",
    "note3": "*** Requiere una cuenta gratuita de la comunidad myboardmaker.com y está destinado únicamente al almacenamiento de actividades."
  },
  "columnHeadings": {
    "community": "COMUNIDAD",
    "onetime": "COMPRA ÚNICA*",
    "personal": "PERSONAL",
    "professional": "PROFESIONAL",
    "organization": "ORGANIZACIÓN*"
  },
  "mobileHeadings": {
    "community": "Comunidad",
    "onetime": "Compra única*",
    "personal": "Personal",
    "professional": "Profesional",
    "organization": "Organización*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Activaciones",
    "languages": "Idiomas**",
    "licensing": "Licencia",
    "pcsSymbols": "Símbolos PCS",
    "templates": "Plantillas",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Reproducir actividades como instructor",
    "playActivitiesStudent": "Reproducir actividades como estudiante",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Gestión del instructor",
    "studentManagement": "Gestión del estudiante",
    "assignStudentActivities": "Asignar actividades a los estudiantes",
    "cloudStorage": "Almacenamiento en la nube",
    "createAndJoin": "Crear y unirse a grupos",
    "accessCommunity": "Acceso a más de 120 000 actividades de la comunidad",
    "shareActivity": "Compartir actividades en la comunidad",
    "curriculum": "Plan de estudios y contenidos",
    "activitiesToGo": "Actividades de Boardmaker para realizar",
    "instructionalSolutions": "Soluciones didácticas",
    "premiumActivities": "Actividades prémium",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 dispositivos",
    "unlimited": "Ilimitado",
    "byKey": "Clave de licencia",
    "symbols": "Más de 80 000",
    "templates": "Más de 600",
    "languages": "12",
    "login": "Iniciar sesión",
    "yes": "Sí",
    "yesNote": "SÍ***",
    "no": "No"
  }
}